export const fireSerpPixelFunction = (cid,et, payout = "", txid = "", currency = "") => {
    let IMG = document.createElement('img');
  
    let src = `https://donsorsstaingham.com/postback?cid=${cid}&et=${et}`;
  
    if (txid) {
      src += `&txid=${txid}`;
    }
  
    if (payout) {
      src += `&payout=${payout}`;
    }

    if (currency) {
        src += `&currency=${currency}`;
      }
  
    IMG.src = src;
    IMG.width = 0;
    IMG.height = 0;
    IMG.style.display = "none";
    IMG.alt = ''; // Empty alt for decorative/tracking images (WCAG compliance)
    IMG.setAttribute('aria-hidden', 'true'); // Hide from screen readers
  
    document.getElementById('root').appendChild(IMG);
  };
  